import { Pipe, PipeTransform } from '@angular/core';

import { JOB_ROLE_MAP } from '../global.constants';


@Pipe({
  name: 'jobCustomer'
})
export class JobCustomerPipe implements PipeTransform {

  transform<
    T extends {
      user?: {
        givenName?: string;
        familyName?: string;
      };
      role?: string;
    },
  >(
    users: T[], asString = true
  ): string | T['user'] {
    if (!users?.length) { return 'None'; }
    const user = users.find((u) => u.role === JOB_ROLE_MAP.customerRole);

    if (asString && !user?.user) {
      return 'None';
    } else if (asString && user?.user){

      return [
        user.user.givenName,
        user.user.familyName,
      ]
        .map((s) => s?.trim())
        .filter(Boolean)
        .join(' ');

    } else {
      return user?.user;
    }
  }

}
 
